module.exports = __webpack_public_path__ + "img/ic_d_px@2x.586b8922.png";